import { useTheme } from '@mui/material';

export const IntroIcon5 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M30 6c2.206 0 4 1.794 4 4v1.862l-2-.011V10c0-1.106-.894-2-2-2H10c-1.106 0-2 .894-2 2v20c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V17.903l2 .012V30c0 2.206-1.794 4-4 4H10c-2.206 0-4-1.794-4-4V10c0-2.206 1.794-4 4-4h20ZM20 18c.55 0 1 .45 1 1v7h2c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1h2v-6h-1.5c-.55 0-1-.45-1-1s.45-1 1-1H20Zm0-5.5a1.5 1.5 0 1 1 0 2.999 1.5 1.5 0 0 1 0-2.999Z"
            />
        </svg>
    );
};
